import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

document.addEventListener("DOMContentLoaded", () => {
	document.querySelectorAll(".callout-loan").forEach((section) => {
		const wrapper = section.querySelector(".callout-loan-anim-wrapper");
		const title = section.querySelector(".callout-loan-title");
		const content = section.querySelector(".callout-loan-content");
		const initialBg = section.querySelector(".callout-loan-initial");

		if (!initialBg) return;

		const prefersReducedMotion =
			window.matchMedia("(prefers-reduced-motion: reduce)").matches ||
			document.documentElement.classList.contains("reduce-motion");

		if (prefersReducedMotion) {
			gsap.set(initialBg, { display: "none" });
			return;
		}

		// Split title into word spans for staggered entrance
		if (title) {
			title.innerHTML = title.textContent
				.trim()
				.split(/\s+/)
				.map((w) => `<span style="display:inline-block">${w}</span>`)
				.join(" ");
		}

		const words = title ? [...title.querySelectorAll("span")] : [];

		// Set initial hidden states
		gsap.set(initialBg, { clipPath: "inset(0 0% 0 0)" });
		// if (words.length) gsap.set(words, { opacity: 0, y: 40 });
		// if (content) gsap.set(content, { opacity: 0, y: 40 });

		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: wrapper,
				start: "40% center",
				// markers: true,
			},
		});

		// 1. Title words stagger in
		// if (words.length) {
		// 	tl.to(words, {
		// 		opacity: 1,
		// 		y: 0,
		// 		stagger: 0.07,
		// 		duration: 0.7,
		// 		ease: "power2.out",
		// 	});
		// }

		// 2. Content fades in and up
		// if (content) {
		// 	tl.to(
		// 		content,
		// 		{
		// 			opacity: 1,
		// 			y: 0,
		// 			duration: 0.7,
		// 			ease: "power2.out",
		// 		},
		// 		words.length ? "-=0.15" : 0
		// 	);
		// }

		// 3. Initial bg wipes away on scroll (scrubbed separately)
		gsap.timeline({
			scrollTrigger: {
				trigger: wrapper,
				start: "25% 60%",
				end: "75% 60%",
				scrub: 1.25,
				// markers: true,
			},
		}).to(initialBg, {
			clipPath: "inset(0 100% 0 0)",
			ease: "none",
		});
	});
});
